export const roundMoneyFormat = (num) => {
    const x = Math.pow(10, 2);
    return Math.round(num * x) / x;
};
